export default function setBreadcrumbsScrollPosition () {
  const breadCrumbsScrollBar = Array.from(document.getElementsByClassName('vsd-breadcrumbs'))[0]
  if (!breadCrumbsScrollBar || !breadCrumbsScrollBar.scrollTo) return
  breadCrumbsScrollBar.scrollTo({ left: breadCrumbsScrollBar.scrollWidth })
}
